var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"toggle-pill",class:{ 'toggle-pill--on': _vm.value },attrs:{"type":"button","aria-pressed":_vm.value,"disabled":_vm.disabled},on:{"click":_vm.toggle}},[_c('span',{staticClass:"toggle-pill__track"}),_c('span',{staticClass:"toggle-pill__thumb"})])
}
var staticRenderFns = []

export { render, staticRenderFns }